import React, { useState } from "react"
import { useSelector, shallowEqual } from "react-redux"
import { Redirect } from "react-router-dom"
import { Header } from "./header/Header"
import AnchorsPositioningPage from "./anchors-positioning/AnchorsPositioningPage"
import SensorsPage from "./sensors/SensorsPage"

export const MapInfrastructurePage = ({ history }) => {
	const [page, setPage] = useState("network")

	const { selectedSite, userClaims } = useSelector(
		state => ({
			selectedSite: state.profile?.currentSite,
			userClaims: state.auth.claims
		}),
		shallowEqual
	)

	const UIEvents = {}

	if (!selectedSite) return <Redirect exact={true} to="/dashboard" />
	return (
		<>
			<Header page={page} setPage={setPage} />
			{selectedSite && page === "network" && <AnchorsPositioningPage setPage={setPage} />}
			{selectedSite && page === "sensors" && <SensorsPage setPage={setPage} />}
		</>
	)
}
